import React, {ReactChild, ReactElement, ReactNode, ReactNodeArray} from 'react';
import PlaceholderBlock, {variants as PlaceholderBlockVariant} from '../PlaceholderBlock/PlaceholderBlock';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph from '../Text/Paragraph/Paragraph';
import {Alignment} from '../../../types';

import './SectionTitleAndSubtitle.scss';

export interface SectionTitleAndSubtitleProps {
  title?: ReactChild;
  text?: ReactNode | ReactNodeArray;
  section?: ReactChild;
  className?: string;
  alignment?: Alignment;
}

function SectionTitleAndSubtitle({
  title,
  text,
  section,
  className,
  alignment = Alignment.LEFT,
}: SectionTitleAndSubtitleProps): ReactElement {
  return (
    <div className={`sectionTitleAndSubtitle sectionTitleAndSubtitle--${alignment} ${className || ''}`.trim()}>
      {section ? (
        <Headers headerType={HeaderType.H6} alignment={alignment} className="sectionTitleAndSubtitle__section">
          {section}
        </Headers>
      ) : null}
      {title ? (
        <Headers headerType={HeaderType.H2} alignment={alignment}>
          {title}
        </Headers>
      ) : (
        <PlaceholderBlock variant={PlaceholderBlockVariant.quarter} />
      )}

      {text && (
        <Paragraph alignment={alignment} className="sectionTitleAndSubtitle__subtitle">
          {text}
        </Paragraph>
      )}
    </div>
  );
}

export default SectionTitleAndSubtitle;
